/**
 * @fileoverview Agent definition for plot-expander-v1.
 *
 * Expands a brief written plot outline into detailed prose paragraphs
 * based on the story's projected word count.
 *
 * Target density is tier-based (via computePlotScopeGuidance).
 *
 * @category narrative.story.plot
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'plot-expander-v1',
  kind: 'primitive',
  name: 'Written Plot Expander',
  description: 'Expands a brief written plot outline into detailed prose paragraphs based on the story\'s projected word count.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.plot',
    usedBy: [
      'primitives/use-plot-expander-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'plot-planner-v1',
    ],
  },
};
